import type { StoreDetailsNotificationChannel } from '../../../../types/features/storeDetails/notifications';

export const STORE_DETAILS_NOTIFICATION_CHANNEL_OPTIONS: Array<{
    value: StoreDetailsNotificationChannel;
    label: string;
}> = [
    { value: 'in_app', label: 'In app' },
    { value: 'email', label: 'Email' },
    { value: 'both', label: 'Both' },
];
